import { render, staticRenderFns } from "./upload-case-main.vue?vue&type=template&id=2149a39f&"
import script from "./upload-case-main.vue?vue&type=script&lang=js&"
export * from "./upload-case-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports